import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardAdmin implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
    return this.checkLogin();
  }

  checkLogin(): boolean {
    if (this.checkToken()) { 
      return true; 
    }

    // Navigate to the login page with extras
    this.router.navigate(['/admin/login']);
    return false;
  }

  checkToken() {
    return sessionStorage.getItem('admin_token');
  }

}




